module.exports = __webpack_public_path__ + "img/2.57703c5b.png";